import Decimal from "decimal.js"

export const validatePrecision =
  ({ name, precision, message }) =>
  (value) => {
    const number = new Decimal(value)

    const parts = String(number).split(".")
    const decimals = parts[1] // undefined for integers, string for decimals

    if (decimals && decimals.length > precision) {
      return (
        message ??
        `${name} can only be specified up to ${precision} decimal places`
      )
    }
  }
